'use client';

import _defineProperty from "/codebuild/output/src4167/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/codebuild/output/src4167/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["forceMount"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx } from 'react/jsx-runtime';
import { forwardRef, useEffect } from 'react';
import { useScrollAreaContext } from '../ScrollArea.context.mjs';
import { ScrollAreaScrollbarAuto } from './ScrollAreaScrollbarAuto.mjs';
import { ScrollAreaScrollbarHover } from './ScrollAreaScrollbarHover.mjs';
import { ScrollAreaScrollbarScroll } from './ScrollAreaScrollbarScroll.mjs';
import { ScrollAreaScrollbarVisible } from './ScrollAreaScrollbarVisible.mjs';
var ScrollAreaScrollbar = forwardRef(function (props, forwardedRef) {
  var forceMount = props.forceMount,
    scrollbarProps = _objectWithoutProperties(props, _excluded);
  var context = useScrollAreaContext();
  var onScrollbarXEnabledChange = context.onScrollbarXEnabledChange,
    onScrollbarYEnabledChange = context.onScrollbarYEnabledChange;
  var isHorizontal = props.orientation === "horizontal";
  useEffect(function () {
    isHorizontal ? onScrollbarXEnabledChange(true) : onScrollbarYEnabledChange(true);
    return function () {
      isHorizontal ? onScrollbarXEnabledChange(false) : onScrollbarYEnabledChange(false);
    };
  }, [isHorizontal, onScrollbarXEnabledChange, onScrollbarYEnabledChange]);
  return context.type === "hover" ? /* @__PURE__ */jsx(ScrollAreaScrollbarHover, _objectSpread(_objectSpread({}, scrollbarProps), {}, {
    ref: forwardedRef,
    forceMount: forceMount
  })) : context.type === "scroll" ? /* @__PURE__ */jsx(ScrollAreaScrollbarScroll, _objectSpread(_objectSpread({}, scrollbarProps), {}, {
    ref: forwardedRef,
    forceMount: forceMount
  })) : context.type === "auto" ? /* @__PURE__ */jsx(ScrollAreaScrollbarAuto, _objectSpread(_objectSpread({}, scrollbarProps), {}, {
    ref: forwardedRef,
    forceMount: forceMount
  })) : context.type === "always" ? /* @__PURE__ */jsx(ScrollAreaScrollbarVisible, _objectSpread(_objectSpread({}, scrollbarProps), {}, {
    ref: forwardedRef
  })) : null;
});
export { ScrollAreaScrollbar };